import type { Board } from './board.js';
import { freeTileIds, isFree, removePair } from './board.js';
import type { Tile } from './tile.js';
import { tilesPair } from './tile.js';

export interface MahjongRules {
  canPair(board: Board, byId: (id: string) => Tile, a: string, b: string): boolean;
  applyPair(board: Board, a: string, b: string): Board;
  isWon(board: Board): boolean;
  /** True if no legal pair remains among free tiles. */
  isStuck(board: Board, byId: (id: string) => Tile): boolean;
}

export const standardRules: MahjongRules = {
  canPair(board, byId, a, b) {
    if (a === b) return false;
    if (!isFree(board, a) || !isFree(board, b)) return false;
    const ta = byId(a);
    const tb = byId(b);
    return tilesPair(ta, tb);
  },
  applyPair(board, a, b) {
    return removePair(board, a, b);
  },
  isWon(board) {
    return board.tiles.size === 0;
  },
  isStuck(board, byId) {
    const free = freeTileIds(board);
    for (let i = 0; i < free.length; i++) {
      for (let j = i + 1; j < free.length; j++) {
        if (tilesPair(byId(free[i]!), byId(free[j]!))) return false;
      }
    }
    return true;
  },
};
